import React from 'react';
import { string, object, node } from 'prop-types';

import Layout from '../../components/Layout';
import Title from '../../components/Title';
// import '../../styles/less/global-style.less';

const TemplateSimple = ({ pageTitle, children, data }) => (
  <Layout pageTitle={pageTitle} data={data}>
    <Title title={pageTitle} />
    <section className="slice bg-3">
      <div className="w-section inverse">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">{children}</div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

TemplateSimple.propTypes = { pageTitle: string, children: node.isRequired, data: object };

TemplateSimple.defaultProps = { pageTitle: '', data: {} };

export default TemplateSimple;
